const iconNames: { [key: string]: string } = {
    back: 'ion-android-arrow-back',
    add: 'ion-android-add',
    menu: 'ion-android-menu',
    close: 'ion-android-close',
    submit: 'ion-android-send',
    save: 'ion-android-clipboard',
    error: 'ion-android-warning',
    refresh: 'ion-android-refresh',
};

export default iconNames;
